import React from 'react';
import { Button, Container, Reveal } from '@/components/ui';
import { siteConfig } from '@/config/site.config';

/**
 * Simple contact CTA for the résumé/portfolio product variant (§11) — a
 * `mailto:` link rather than the business template's full inquiry form
 * (`ContactUs`), since a personal portfolio's contact needs are lighter. See
 * `src/pages/ResumeDemo.tsx`.
 */
const ResumeContact: React.FC = () => {
    return (
        <section id="resume-contact" className="resume-contact">
            <Container>
                <Reveal as="div" className="resume-contact-box">
                    <h2 className="section-title">Let&rsquo;s Work Together</h2>
                    <p className="resume-contact-text">
                        Have a project in mind? I&rsquo;d love to hear about it.
                    </p>
                    <Button as="a" href="mailto:hello@example.com" variant="primary">
                        hello@example.com
                    </Button>
                </Reveal>
            </Container>
            <p className="resume-contact-footer">
                &copy; {new Date().getFullYear()} {siteConfig.brand.name}
            </p>
        </section>
    );
};

export default ResumeContact;
